<!-- 销售流水 -->
<template>
    <div class='page_content'>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <el-form :inline="true" label-width="100px" :model="getRequestData" class="demo-form-inline" v-if="pageShowData.jurHead" size="mini">
                    <template v-for="(formOneValue, formOneKey) in pageShowData.jurHead.jurconfigform">
                        <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1" :key="formOneKey">
                            <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                            <!-- 开始时间 -->
                            <el-date-picker v-if="formOneValue.entityField == 'start'" size="mini" class="form_codition" v-model="getRequestData[formOneValue.entityField]" format="yyyy 年 MM 月 dd 日"
                                            value-format="timestamp" type="date" placeholder="选择日期"></el-date-picker>
                            <!-- 结束时间 -->
                            <el-date-picker v-else-if="formOneValue.entityField == 'end'" @change="changeTime" size="mini" class="form_codition" v-model="getRequestData[formOneValue.entityField]"
                                            format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期"></el-date-picker>
                            <!-- 检索方案 -->
                            <el-input v-else-if="formOneValue.fieldType == 'search'" @clear="clear(formOneValue.setField)" class="form_codition" clearable v-model="getRequestData[formOneValue.entityField]"
                                      @keyup.enter.native="openSearch('fm', formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)">
                                <el-button @click="openSearch('fm', formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"></el-button>
                            </el-input>
                            <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" class="form_codition" v-model="getRequestData[formOneValue.entityField]" placeholder="请选择">
                                <el-option label="全部" value=""></el-option>
                                <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.value" :value="item.key">
                                </el-option>
                            </el-select>
                            <el-input v-else v-model.trim="getRequestData[formOneValue.entityField]" size="mini" class="form_codition" :maxlength="$store.state.inputLength"></el-input>

                        </el-form-item>
                    </template>

                    <el-form-item>
                        <el-button type="primary" size="mini" @click="searchData">查询</el-button>
                    </el-form-item>
                    <el-form-item v-if="returnData.list.length > 0">
                        <div style="font-size: 14px;text-align: right;">合计：<span style="color:red;font-size: 16px">{{
                totalMoney }}</span></div>
                    </el-form-item>
                </el-form>

            </div>
        </div>
        <div class="page_content_center">
            <el-table ref="elTable" @sort-change="sortChange" :summary-method="getSummaries" show-summary v-if="pageShowData.jurTableVo" @selection-change="handleSelectionChange" stripe :data="returnData.list"
                      :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini">
                <!-- 主表单 -->
                <el-table-column type="selection" width="40"></el-table-column>
                <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                    <el-table-column :sortable="tableValye.isSort == 1?'custom':false" align="center" v-if="tableValye.isShow == 1" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField"
                                     show-overflow-tooltip :min-width="tableValye.fieldWeight">
                        <template slot-scope="scope">
                            <!-- 开票日期 -->
                            <template v-if="tableValye.fieldType == 'date'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </template>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField] }}</a>
                            </span>
                            <el-tag v-else-if="tableValye.fieldType == 'formatter'" size="mini">
                                {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</el-tag>
                            <span v-else>{{ scope.row[tableValye.entityField] }}</span>

                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>

        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :smId="smId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
        <el-dialog v-if="dialogExcel" :title="title" :visible.sync="dialogExcel" width="1000px" :before-close="closeExcel">
            <compareUpload v-if="dialogExcel && actionType == 8" :excelTable="importExcelTableName" :importType="importType" @fileSuccess='fileSuccess' @closeExcel="closeExcel" />
            <customUpload v-if="dialogExcel && actionType == 10" :excelTable="importExcelTableName" :bankList="bankList" :tableHeadArr="salesFlow.ZDY" :importType="importType" @fileSuccess='fileSuccess'
                          @closeExcel="closeExcel" />
            <importListAction v-if="dialogExcel && (actionType == 5 || actionType == 6)" :tableList="tableList" :submitUrl="'runwaterinsertList'" :uploadUrl="uploadUrl" @fileSuccess='fileSuccess'
                              @closeExcel="closeExcel">
            </importListAction>
        </el-dialog>
        <el-dialog v-if="changeCm" title="修改付款方" :visible.sync="changeCm" width="400px%">
            <el-form label-width="100px" @submit.native.prevent :inline="true">
                <el-row>
                    <el-form-item label="付款方">
                        <label slot="label" :style="$common.labelStyle('付款方')" v-html="'付款方'"></label>
                        <!-- <el-input @keyup.enter.native="openSearch('157783642640384',0, 'cmName', 'cmName,cmId')" -->
                        <el-tooltip class="item" :disabled="sendData.cmName == null || sendData.cmName == '' ? true : false || sendData.cmName.length <= 9" effect="dark" :content="sendData.cmName"
                                    placement="bottom-start">
                            <el-input @keyup.enter.native="openSearch('ed', '8820873997127689', 0, 'cmName', 'cmName,cmId')" class="form_codition" v-model.trim="sendData.cmName" clearable>
                                <el-button @click="openSearch('ed', '8820873997127689', 0, 'cmName', 'cmName,cmId')" slot="append" icon="el-icon-search"></el-button>
                            </el-input>
                        </el-tooltip>
                    </el-form-item>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="changeCm = false">取 消</el-button>
                <el-button @click="confirmUp" type="primary">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 新增流水 -->
        <el-dialog title="新增流水" :visible.sync="addDialogVisible" width="860px" :close-on-click-modal="false" @close="addDialogVisible = false">
            <el-form label-width="110px" :model="sendDataInfo" ref="addForm" size="mini" :show-message="false" class="add-runwater-form">
                <el-row :gutter="24">
                    <el-col :span="12" v-for="(formOneValue, formOneKey) in addFormList" :key="formOneKey" v-if="formOneValue.isShow == 1">
                        <el-form-item :label="formOneValue.showField" :prop="formOneValue.entityField"
                                      :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                            <!-- 检索 -->
                            <el-tooltip v-if="formOneValue.fieldType == 'search'" class="item"
                                        :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || (sendDataInfo[formOneValue.entityField] || '').length <= 9"
                                        effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                <el-input class="form_codition" clearable v-model.trim="sendDataInfo[formOneValue.entityField]"
                                          @keyup.enter.native="openSearch('ed', formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                          :maxlength="$store.state.inputLength">
                                    <el-button @click="openSearch('ed', formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"></el-button>
                                </el-input>
                            </el-tooltip>
                            <!-- 日期 -->
                            <el-date-picker v-else-if="formOneValue.fieldType == 'date'" size="mini" v-model="sendDataInfo[formOneValue.entityField]" format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date"
                                            placeholder="选择日期" style="width:100%"></el-date-picker>
                            <!-- 下拉 -->
                            <el-select v-else-if="formOneValue.fieldType == 'formatter' && formOneValue.formatterContent" clearable size="mini" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择" style="width:100%">
                                <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)" :key="matItem.key" :label="matItem.value" :value="matItem.key"></el-option>
                            </el-select>
                            <!-- 文本域 -->
                            <el-input v-else-if="formOneValue.fieldType == 'textarea'" type="textarea" :rows="2" v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                            <!-- 金额/数字 -->
                            <el-input v-else-if="formOneValue.fieldType == 'number'" type="number" v-model.number="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                            <!-- 普通输入 -->
                            <el-input v-else v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addDialogVisible = false">取 消</el-button>
                <el-button @click="confirmAdd" type="primary">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue"
import salesFlow from './salesFlow';
import NP from "number-precision";
import importListAction from "@/components/importListAction.vue";
import customUpload from '@/components/customUpload.vue';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        importListAction,
        customUpload
    },
    data() {
        //这里存放数据
        return {
            salesFlow: salesFlow,
            totalMoney: 0,
            actionType: 0,
            tableHeight: 0,
            getRequestData: {
                "creater": '',
                "page": 1,
                "rows": 10,
                start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
                end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
                cmName: '', //	付款方名称
                cmId: '',
                rwState: ''
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: []
            },
            buttonList: [],

            pageShowData: [],
            formDataList: null,
            selectedDataIndex: 0,
            multipleSelection: [],
            userOneList: [],
            seTitle: "", //检索
            DialogVisible: false,
            seWidth: '0',
            seId: 0,
            smId: 0,
            sField: '',
            toField: "",
            parentSearchData: {},
            requesUrl: "",
            dialogExcel: false,
            importType: 'PRODUCT',
            importExcelTableName: 'TMP_BT_PRODUCT',
            changeCm: false,
            cmName: '',
            ormId: '',
            sendData: {
                cmName: '',
                cmId: '',
                rwIds: ''
            },
            addDialogVisible: false,
            addFormList: [], // 动态新增表单配置 (jurconfigform)
            sendDataInfo: {}, // 动态新增表单数据
            seType: '', // 检索字段标识
            requesUrl: this.$store.getters.getConfig.requestUrl,
            ormId: JSON.parse(sessionStorage.getItem('userInfo')).ormId,
            uploadUrl: "",
            tableList: [],
            title: "",
            bankList: [],
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        'getRequestData.smName': {
            handler: function (newValue, oldValue) {
                if (newValue == '') {
                    this.getRequestData.cmId = ''
                }
            },
            deep: true,
        },
        'getRequestData.smName': {
            handler: function (newValue, oldValue) {
                if (newValue == '') {
                    this.getRequestData.cmId = ''
                }
            },
            deep: true,
        }
    },
    created() {
        this.requesUrl = this.$store.getters.getConfig.requestUrl;
        this.ormId = sessionStorage.getItem('ormId')
        this.getPageInfo()
    },
    //方法集合
    methods: {
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (column.property == 'money' || column.property == 'settleMoney' || column.property == 'unsettleMoney') {
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return this.$common.getDecimalInfo(3, NP.plus(prev, curr));
                            } else {
                                return prev;
                            }
                        }, 0);
                    } else {
                        sums[index] = '';
                    }
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        },
        sortChange(column) {
            this.returnData.list = this.$common.sortChange(column, this.returnData.list, this.pageShowData.jurTableVo.jurconfigtable, 'entityField')
        },
        // 勾选明细
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        async confirmUp() {
            let responseData = await this.$http.updateRunwater(
                this.sendData
            )
            if (responseData.status == 200) {
                this.changeCm = false
                this.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        // 初始化动态新增表单数据
        initAddFormData() {
            this.sendDataInfo = {}
            if (this.addFormList && this.addFormList.length > 0) {
                this.addFormList.forEach(item => {
                    if (item.fieldType == 'date') {
                        this.$set(this.sendDataInfo, item.entityField, new Date(new Date().toLocaleDateString()).getTime())
                    } else if (item.fieldType == 'number') {
                        this.$set(this.sendDataInfo, item.entityField, '')
                    } else {
                        this.$set(this.sendDataInfo, item.entityField, '')
                    }
                })
            }
            this.$nextTick(() => {
                if (this.$refs.addForm) {
                    this.$refs.addForm.clearValidate()
                }
            })
        },
        // 新增流水
        confirmAdd() {
            this.$refs.addForm.validate(async (valid) => {
                if (valid) {
                    let sendParams = JSON.parse(JSON.stringify(this.sendDataInfo))
                    let responseData = await this.$http.runwaterAdd(sendParams)
                    if (responseData.status == 200) {
                        this.$message({ message: '新增成功', type: 'success' })
                        this.addDialogVisible = false
                        this.initAddFormData()
                        this.getDataList()
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: 'error'
                        })
                    }
                } else {
                    return false
                }
            })
        },
        //表格数据写入excel
        exportExcel(arrName, listName, title) {
            this.$common.exportData(this[arrName], this[listName], title)
        },
        // 记录汇总
        recordSummary(arrName, listName, title) {
            this.$refs.recordSummary.openBox(this[arrName], this[listName], title)
        },
        // 记录过滤
        recordFiltering(arrName, listName, title) {
            this.$refs.recordFiltering.openBox(this[arrName], this[listName], title)
        },
        closeExcel(refresh) {
            this.dialogExcel = false
            if (refresh) this.getDataList()
        },
        // 监听子组件   导入excel 成功
        fileSuccess(val) {
        },
        // 导入EXCEL
        handleExcel() {
            this.dialogExcel = true;
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(toField, sId, index, type, sField) {
            this.DialogVisible = true;
            this.seId = sId;
            this.sField = sField;
            this.toField = toField;
            this.parentSearchData = {}
            if (toField == 'fm') {
                this.parentSearchData[type] = this.getRequestData[type];
            } else if (this.addDialogVisible) {
                this.parentSearchData[type] = this.sendDataInfo[type];
            } else {
                this.parentSearchData[type] = this.sendData[type];
            }
        },
        //检索带回数据
        changeInputModel(val) {
            console.log('返回', val);
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val);
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            if (this.toField == 'fm') {
                arr.forEach((item) => {
                    this.getRequestData[item] = val[item];
                });
            } else if (this.addDialogVisible) {
                arr.forEach((item) => {
                    this.sendDataInfo[item] = val[item];
                });
            } else {
                arr.forEach((item) => {
                    this.sendData[item] = val[item];
                });
            }
        },
        getSeWidth(e) {
            // console.log(e);
            this.seWidth = e + "%";
        },
        getWidth(e) {
            // console.log(e);
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            // console.log(e);
            this.seTitle = e;
        },

        isShowData(name, value) {
            switch (name) {
                case 'customerList':
                    var dataInfo = sessionStorage.getItem('selectCustomerData')
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo)
                        this.getRequestData.smId = dataInfo.smId
                        this.getRequestData.smName = dataInfo.smName
                    }

                    break;

                default:
                    this.getRequestData[name] = value

            }
        },
        //获取表头信息
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path)
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId]
            })
            if (responseData.status == 200) {
                this.pageShowData = responseData.result
                this.formDataList = this.pageShowData.jurTableVo
                // 保存动态新增表单配置 (jurFormVoList 中主表单 jciType == 1)
                if (this.pageShowData.jurFormVoList && this.pageShowData.jurFormVoList.length > 0) {
                    let mainForm = this.pageShowData.jurFormVoList.filter(item => item.jciType == 1)
                    if (mainForm.length > 0) {
                        this.addFormList = mainForm[0].jurconfigform.filter(f => f.isShow == 1)
                        this.initAddFormData()
                    }
                }
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getDataList();
                this.getButtonList();
                // this.formDataList[1].isShowForm = 1
                // this.formDataList[2].isShowForm = 1
                // this.formDataList[3].isShowForm = 1
                // this.formDataList[4].isShowForm = 1
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        clear(val) {
            if (val) {
                var arr = val.split(",")
                arr.forEach(item => {
                    this.$set(this.getRequestData, item, "")
                })
            }
        },
        // 动作集合
        async actionSet(actionData) {
            console.log('actionSet', actionData);
            switch (actionData.actionType) {
                case 3: // 新增
                    this.actionType = 3
                    this.initAddFormData()
                    this.addDialogVisible = true
                    break;
                case 1:
                    if (this.returnData.list.length < 1) {
                        this.$message({
                            message: "暂无数据",
                            type: "error",
                        });
                        return false;
                    }
                    if (this.multipleSelection.length < 1) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.sendData.rwIds = []
                    this.multipleSelection.forEach(v => {
                        this.sendData.rwIds.push(v.rwId)
                    })
                    this.changeCm = true
                    break;
                case 2:
                    this.delDataAction()
                    break;
                case 4:
                    this.exportFun()
                    break;
                case 8:
                    this.actionType = 8
                    this.title = "导入流水"
                    this.handleExcel()
                    break;
                case 9:
                    window.location.href = this.requesUrl + `/runwater/importTemplate?ormId=${String(this.ormId)}`;
                    break;
                case 5:
                    this.actionType = 5
                    this.uploadUrl = "/runwater/uploadGsyh"
                    this.tableList = salesFlow.GSYH
                    this.title = "导入工商流水"
                    this.handleExcel()
                    break;
                case 6:
                    this.actionType = 6
                    this.uploadUrl = "/runwater/uploadzyhh"
                    this.tableList = salesFlow.ZYYH
                    this.title = "导入中原流水"
                    this.handleExcel()
                    break;
                case 10:
                    this.actionType = 10
                    this.title = "导入自定义流水"
                    let res = await this.$http.readRuleQueryInit({ name: "" })
                    this.bankList = res.result
                    console.log(res)

                    this.handleExcel()
                    break;
            }
        },
        async exportFun() {
            this.getRequestData.page = 1;
            await this.getDataList()
            if (this.returnData.list.length == 0) {
                this.$message({ type: 'error', message: "暂无数据！" })
                return
            }
            window.location.href = this.requesUrl + '/runwater/exportRunwaterData?ormId='
                + String(this.ormId) + '&cmId=' + this.getRequestData.cmId
                + '&start=' + this.getRequestData.start + '&end=' + this.getRequestData.end
                + '&page=' + this.getRequestData.page + '&rows=' + this.getRequestData.rows + '&creater=' + this.getRequestData.creater
                + '&cmName=' + this.getRequestData.cmName
                + '&rwState=' + this.getRequestData.rwState

        },
        // 删除数据
        delDataAction() {
            if (this.returnData.list.length < 1) {
                this.$message({
                    message: "暂无数据",
                    type: "error",
                });
                return false;
            }
            if (this.multipleSelection.length < 1) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            this.sendData.rwIds = []
            this.multipleSelection.forEach(v => {
                this.sendData.rwIds.push(v.rwId)
            })

            this.$confirm('确定删除该数据吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                var delData = {
                    ids: this.sendData.rwIds
                }
                let responseData = await this.$http.runwaterDel(delData)
                if (responseData.status == 200) {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });

                    this.getDataList()
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }

            }).catch(() => { });
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        showPrintPlan() {
            var dataInfo = this.returnData.list[this.selectedDataIndex]
            if (!dataInfo) {
                this.$message({
                    message: '请先选中要操作的数据',
                    type: 'error'
                });
                return false
            }
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                var info = this.returnData.list[this.selectedDataIndex]
                this.$refs.printPlan.openDia(info.woamId)
            } else {
                return
            }
        },

        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },

        // 获取数据列表
        async getDataList() {
            this.getrunWaterMoney()
            let responseData = await this.$http.runwaterQueryInit(this.getRequestData)
            // console.log(responseData);
            if (responseData && responseData.status == 200) {
                let resData = JSON.parse(JSON.stringify(responseData))
                this.returnData.list = this.$common.getIndex(resData.result.list)
                this.returnData.total = resData.result.total
                this.selectedDataIndex = 0
                this.$nextTick(() => {
                    this.$refs['elTable'].doLayout()
                })

            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        // 获取数据列表
        async getrunWaterMoney() {
            let responseData = await this.$http.runWaterMoney(this.getRequestData)
            // console.log(responseData);
            if (responseData && responseData.status == 200) {
                this.totalMoney = responseData.result

            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },


        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
//获取状态
        getIsGsp(str, val) {
            try {
                str && str.replace(/\\/g, '')
                let arr = JSON.parse(str)
                let len = arr.length
                let newStr = ''
                for (let i = 0; i < len; i++) {
                    if (arr[i].key === val) {
                        newStr = arr[i].value
                        break;
                    }
                }
                return newStr
            } catch (ex) {
                return str
            }
        },

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.add-runwater-form .el-form-item {
    margin-bottom: 16px;
}
.add-runwater-form .el-form-item__label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 4px;
    line-height: 28px;
}
.add-runwater-form .el-form-item__content {
    line-height: 28px;
}
.add-runwater-form .el-form-item.is-required .el-form-item__label:before {
    margin-right: 2px;
}
.add-runwater-form .el-input__inner,
.add-runwater-form .el-textarea__inner {
    border-radius: 3px;
    height: 28px;
    line-height: 28px;
}
.add-runwater-form .el-input__icon,
.add-runwater-form .el-input-group__append {
    height: 28px;
    line-height: 28px;
}
.add-runwater-form .el-textarea__inner {
    min-height: 54px !important;
    height: auto;
    line-height: 1.5;
}
.add-runwater-form .el-date-editor.el-input,
.add-runwater-form .el-date-editor.el-input__inner {
    width: 100%;
}
</style>